import IsologoTransition from "@/components/common/IsologoTransition/IsologoTransition";
import React from "react";
import { Expertise } from "@/components/Services/Expertise/Expertise";
import styles from "./ExpertiseAreas.module.scss";

export default function ExpertiseAreas({ messages }) {
  return (
    <div className={styles.transitionContainer}>
      <IsologoTransition />
      <div className={styles.expertiseWrapper}>
        <Expertise background="primary" expertiseSection={messages} />
      </div>
    </div>
  );
}
